import { inject, Injectable } from '@angular/core';
import { MessagesUiService } from '@okcargo-apps/messages-ui';
import { AccountService, FreightShipperService } from '@okcargo-apps/shared-application-ionic';
import { ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { FreightService } from '../../freight/application/freight.service';
import { MarketService } from '../../market/application/market.service';

@Injectable({
  providedIn: 'root',
})
export class RefreshDataService {
  private readonly freightService = inject(FreightService);
  private readonly freightShipService = inject(FreightShipperService);
  private readonly marketService = inject(MarketService);
  private readonly accountService = inject(AccountService);
  private readonly messagesUiService = inject(MessagesUiService);

  // constructor() {}

  refreshAll(): void {
    this.freightService.refreshFreightsInprogress();
    this.freightService.refreshFreightsFinished();
    this.freightService.refreshFreightstWithPendingDocumentation();
    this.accountService.hasCapability$(ECapabilities.VIEW_MARKET).subscribe((hasCap) => {
      if (hasCap) {
        this.marketService.refreshFreightsInMarket();
      }
    });
    this.accountService.hasCapability$(ECapabilities.UPLOAD_FREIGHTS).subscribe((hasCap) => {
      if (hasCap) {
        this.freightShipService.refreshFreightsShipNotFinished();
        this.freightShipService.refreshFreightsShipFinished();
      }
    });

    // TODO refresh company documents; refresh invoices

    // TODO refresh users/drivers; refresh vehicles
  }
}
